var Backbone = require('backbone');
var _ = require('underscore');

require('./Forgot.less');


module.exports = Backbone.View.extend({

    el: '.Forgot',

    events: {
        'click .Forgot-buttonForgot': 'onForgotClick',
        'input .Forgot-input': 'onForgotInputChange',
        'keydown .Forgot-input': 'onForgotInputKeyDown'
    },


    initialize: function () {
        _.bindAll(this, 'onForgotInputChange');
    },


    show: function (params) {
        this.$el.addClass('visible');

        if (params.email) {
            this.$('.Forgot-input[name="email"]').val(params.email);
        }

        this.$('.Forgot-input[name="email"]').focus();

        this.onForgotInputChange();
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    onForgotClick: function () {
        var $emailInput = this.$('.Forgot-input[name="email"]');
        var $button = this.$('.Forgot-buttonForgot');
        var email = $emailInput.val();

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();

        //TODO: fix api url
        this._xhr = $.ajax(Urls['submissions:api:forgot']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'email': email
            }),
            success: function (data) {
                $button.removeClass('Button--loading');

                this.showSuccessMessage(email);
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    if (e.status == 400) { //bad request
                        $button.flashClass('Button--shake', 500);
                    } else {
                        alert('Error ' + e.status + ': ' + e.statusText);
                    }
                }

                console.log('error', arguments);
            }.bind(this)
        });
    },


    showSuccessMessage: function (email) {
        this.$('.Forgot-sended')
            .text('E-mail has been sent to ' + email + '!')
            .show();
        this.$('.Forgot-desc, .Forgot-inputLine, .Forgot-buttons').hide();
    },


    onForgotInputKeyDown: function (e) {
        var $emailInput = this.$('.Forgot-input[name="email"]');

        if (e.keyCode == 13) {
            if ($(e.currentTarget).is($emailInput)) {
                if ($emailInput.val()) {
                    this.onForgotClick();
                }
            }

            e.preventDefault();
        }
    },


    onForgotInputChange: function (e) {
        var $emailInput = this.$('.Forgot-input[name="email"]');
        var $button = this.$('.Forgot-buttonForgot');
        var isValid = $emailInput.val();

        $button.toggleClass('Forgot-buttonForgot--active', !!isValid);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/Forgot/Forgot.js
// module id = 106
// module chunks = 0